import type { PartnerFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';
import type { SpecializationFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCourseEntitiesFragments';
import getPartnersForSpecialization from 'bundles/unified-description-page-common/utils/getPartnersForSpecialization';

const getPartnersForCourse = (
  coursePartners?: Array<PartnerFragment> | null,
  activeSpecialization?: SpecializationFragment | null
) => {
  if (activeSpecialization) {
    return getPartnersForSpecialization(activeSpecialization.partners, !!activeSpecialization.coBrandingEnabled);
  } else {
    return coursePartners?.slice(0, 1);
  }
};

export default getPartnersForCourse;
